import { render } from "./TaskBorder.vue?vue&type=template&id=1a1ba270"
import script from "./TaskBorder.vue?vue&type=script&lang=js"
export * from "./TaskBorder.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskBorder.vue?vue&type=style&index=0&id=1a1ba270&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/runner/work/pulse/pulse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__